import { MenuGroup } from '@/resources/MenuGroup';
import { AppCollection } from '@/stores/AppStore';

export const FETCH_MENU_GROUPS_KEY = 'fetch-menu-groups';

export async function fetchMenuGroups(
  store: AppCollection,
  tabId: string,
  eventId: string,
  pageSize = 2,
  pageNumber = 1
) {
  return store.fetchAll<MenuGroup>(MenuGroup.type, {
    filter: {
      menu_tab_id: tabId,
      // library variant of with_group_members: skips groups whose lectures have no video/poster
      scope: 'with_library_members',
    },
    params: [
      {
        key: 'page[size]',
        value: pageSize.toString(),
      },
      {
        key: 'page[number]',
        value: pageNumber.toString(),
      },
    ],
  });
}

export const FETCH_SINGLE_MENU_GROUP_KEY = 'fetch-single-menu-group';

export async function fetchSingleMenuGroup(store: AppCollection, tabId: string) {
  return store.fetch<MenuGroup>(MenuGroup.type, tabId);
}

export const FETCH_ALL_MENU_GROUPS_KEY = 'fetch-all-menu-groups';

export async function fetchAllMenuGroups(
  store: AppCollection,
  tabId: string,
  additionalFilters: Record<string, string>
) {
  const menuGroups: Array<MenuGroup> = [];

  let response = await store.fetchAll<MenuGroup>(MenuGroup.type, {
    filter: {
      menu_tab_id: tabId,
      ...additionalFilters,
    },
    params: [
      {
        key: 'page[size]',
        value: '100',
      },
      {
        key: 'page[number]',
        value: '1',
      },
    ],
  });

  menuGroups.push(...(response.data as Array<MenuGroup>));

  while (response.next) {
    // eslint-disable-next-line no-await-in-loop
    response = await response.next;
    menuGroups.push(...(response.data as Array<MenuGroup>));
  }

  return menuGroups;
}
